<div class="modal-body content width-500 ">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('absenceHeader')}} {{dataInit ? getRessource('create') : getRessource('edit')}}
    </span>
		<div class="content grid cols-2">
			<exg-input [ngModel]="dataModelClone.from | date:'yyyy-MM-dd'"
			           (ngModelChange)="dataModelClone.from = $event" type="date"
			           [caption]="getRessource('from')"
			           [required]="dateValid(dataModelClone.from)" [hintText]="hintText"
                 #VCfrom name="from">
			</exg-input>
			<exg-input [ngModel]="dataModelClone.to | date:'yyyy-MM-dd'"
			           (ngModelChange)="dataModelClone.to = $event" type="date"
			           [required]="dateValid(dataModelClone.to)" [hintText]="hintText"
			           [caption]="getRessource('to')"
                 #VCto name="to">
			</exg-input>
			<exg-input [ngModel]="dataModelClone.noDispoFrom | date:'yyyy-MM-dd'"
			           (ngModelChange)="dataModelClone.noDispoFrom = $event" type="date"
			           [required]="dateValid(dataModelClone.noDispoFrom)" [hintText]="hintText"
			           [caption]="getRessource('noDispoFrom')"
                 #VCnoDispoFrom name="noDispoFrom">
			</exg-input>
			<exg-input [ngModel]="dataModelClone.noDispoTo | date:'yyyy-MM-dd'"
			           (ngModelChange)="dataModelClone.noDispoTo = $event" type="date"
			           [required]="dateValid(dataModelClone.noDispoTo)" [hintText]="hintText"
			           [caption]="getRessource('noDispoTo')"
                 #VCnoDispoTo name="noDispoTo">
			</exg-input>
			<exg-input [(ngModel)]="dataModelClone.deputy" type="text" class="span-2"
			           [caption]="getRessource('deputy')"
                 #VCdeputy name="deputy">
			</exg-input>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        [class.disabled]="
			          !canSave()"
			        class="md-btn">
				{{getGlobal('Save')}}
			</button>
		</div>
	</div>
</div>
